import React from 'react';
import PropTypes from 'prop-types';
import WireMatchHeader from '../common/wire-match-header';
import Wire from '../common/wire';

export default function TitleMatch({ query, wires }) {
  if (!wires.length) {
    return null;
  }

  return (
    <article>
      <WireMatchHeader query={query} text="titled" n={wires.length} />
      {wires.map((wire, index) => <Wire bordered key={`wire-${wire.id}`} wire={wire} position={index + 1} />)}
    </article>
  );
}

TitleMatch.propTypes = {
  query: PropTypes.string.isRequired,
  wires: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
};
